import type { PlanImage } from './woodworking'

/** Transparent hero composition (v4b): fat book with the three-bike rack on the cover + plant stand, dog bowl stand and boot rack + tablet with the real P11 plan + steel "+5 FREE BONUSES" seal. */
export const HERO_COMPOSITE: PlanImage = {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/6c1a724c-31a4-442a-bc25-af15f66c889e/1793813492035_ws-hero-mockup2-a4b6c907.webp',
  alt: 'WELDING PROJECTS THAT SELL™ book showing a three-bike steel rack, with a 3-tier plant stand, a raised dog bowl stand, a boot rack, a tablet with the real P11 plan and a "+5 FREE BONUSES" seal',
  width: 1100,
  height: 968,
}
